import React from 'react'
import Masthead from './Masthead'
import Footer from '../../components/Footer/Footer'
import AnimatedSection from '../../components/Animation/AnimatedSection';
import AOSInit from '../../components/Animation/AOSInit';
import NavBarHome from '../../components/NavBar/NavBarHome';
import PopularCourses from './PopularCourses';
import WhyjointheBootcamp from './WhyjointheBootcamp';
import NextMakerMethodology from './NextMakerMethodology';
import LearnFromTheBest from './LearnFromTheBest';
import StudentTestimonials from './StudentTestimonials/StudentTestimonials';
import OffersSection from './OffersSection';

function HomeBootcamp() {
   return (
      <div className="pt-[92px] flex flex-col min-h-screen overflow-x-hidden">
         <AOSInit />
         <NavBarHome />

         {/* Hero Section */}
         <section id="hero" className="relative">
            <AnimatedSection
               animation="fade-up"
               duration={1200}
               delay={100}
               threshold={1.0}
            >
               <Masthead />
            </AnimatedSection>
         </section>

         {/* Top Courses */}
         <section id="top-courses" className="">
            <AnimatedSection
               animation="fade-up"
               duration={800}
               delay={200}
               threshold={1.0}
            >
               <PopularCourses />
            </AnimatedSection>
         </section>

         {/* Why Join the Bootcamp */}
         <section id="why-join" className="">
            <AnimatedSection
               animation="fade"
               duration={1000}
               delay={200}
               threshold={1.0}
            >
               <WhyjointheBootcamp />
            </AnimatedSection>
         </section>

         {/* Methodology */}
         <section id="methodology" className="">
            <AnimatedSection
               animation="fade-up"
               threshold={1.0}
            >
               <NextMakerMethodology />
            </AnimatedSection>
         </section>


         {/* Top Instructors */}
         <section id="instructors" className="">
            <AnimatedSection
               animation="fade"
               duration={1000}
               delay={200}
               threshold={1.0}
            >
               <LearnFromTheBest />
            </AnimatedSection>
         </section>

         {/* Top Students */}
         <section id="students" className="">
            <AnimatedSection
               animation="fade-down"
               duration={800}
               delay={200}
               threshold={1.0}
            >
               <StudentTestimonials />
            </AnimatedSection>
         </section>

         {/* Offers Section */}
         <section id="offers">
        <AnimatedSection
          animation="fade"
          duration={1000}
          delay={200}
          threshold={1.0}
        >
          <OffersSection />
        </AnimatedSection>
      </section>

         {/* Footer */}
         <section id="footer">
            <Footer
               logo={"/Logo NextMaker.png"}
               bgColor="bg-[#140342]"
               textColor="text-gray-100"
               borderColor="border-gray-400/20"
            />
         </section>
      </div>
   )
}

export default HomeBootcamp